import Utils, { ScreenResolutions } from '@uigy/utils';

export const DRAWER_WIDTH = {
  [ScreenResolutions.small]: 600,
  [ScreenResolutions.medium]: 728,
  [ScreenResolutions.large]: 856,
};
export const DEFAULT_PADDING: number = 52;
export const DRAWER_MIN_WIDTH: number = DRAWER_WIDTH[ScreenResolutions.small];

export function drawerDefaultWidth(): number {
  return DRAWER_WIDTH[Utils.getScreenResolution()];
}
